export default __webpack_public_path__ + "static/media/FX2.bfc41206.mp3";